<template>
    <section class="section-outline" v-if="getTableData">
        <mvtCollapse :disable="disableCollapse"  :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f2 text-bold">{{molang('dpp.propertyMarket.statistics')}}</h2>
                <div class="f5 text-gray" v-show="collapsible.collapsed">{{description}}</div>
                <div v-show="!collapsible.collapsed" class="f5 text-gray">
                    <span>Want to know more about the {{dpp.geo.city}} real estate market?
                        <a :href="glb.appUrl + dpp.geo.marketTrendsPath" class="link">View market stats</a>
                    </span>
                </div>
            </template>
            <template v-slot:default>
            <div class="property-market grid xs-grid-cols-1">

                <div class="grid xs-grid-cols-1">
                    <ul class="tab tab-bookmark">
                        <li v-for="item in sourceTypes" :key="item.value">
                            <button @click="changeFilterBy(item.value)" :class="{active: filterBy == item.value}">
                                {{item.text}}
                            </button>
                        </li>
                    </ul>
                    <ul class="property-market-info grid xs-grid-cols-1 sm-grid-cols-4">
                        <li>
                            <div><span class="dot"></span>{{dpp.geo.address}}</div>
                            <span class="value">{{getTableData.current.value}}</span>
                        </li>
                        <li v-if="!useCountyData">
                            <div><span class="dot"></span>{{dpp.geo.neighborhood }}</div>
                            <span class="value">{{getTableData.neighborhood.value}}</span>
                            <span class="rate" v-if="getTableData.neighborhood.rate" :class="getTableData.neighborhood.class">{{getTableData.neighborhood.rate}} y/y</span>
                        </li>
                        <li v-if="useCountyData">
                            <div><span class="dot"></span>{{dpp.geo.county }}</div>
                            <span class="value">{{getTableData.county.value}}</span>
                            <span class="rate" v-if="getTableData.county.rate" :class="getTableData.county.class">{{getTableData.county.rate}} y/y</span>
                        </li>
                        <li>
                            <div><span class="dot"></span>{{dpp.geo.zipcode}}</div>
                            <span class="value">{{getTableData.zipcode.value}}</span>
                            <span class="rate" v-if="getTableData.zipcode.rate" :class="getTableData.zipcode.class">{{getTableData.zipcode.rate}} y/y</span>
                        </li>
                        <li>
                            <div><span class="dot"></span>{{dpp.geo.city}}</div>
                            <span class="value">{{getTableData.city.value}}</span>
                            <span class="rate" v-if="getTableData.city.rate" :class="getTableData.city.class">{{getTableData.city.rate}} y/y</span>
                        </li>
                      </ul>
                    <div class="property-market-chart" :class="{'no-chart': !chartData}">
                        <mvtChart v-if="chartData" :data="chartData"></mvtChart>
                        <template v-else>
                            {{molang('dpp.propertyMarket.noChart')}}
                        </template>
                    </div>
                </div>
                <div class="f8 stat-attribution">
                    {{molang('dpp.propertyMarket.statisticsByMovoto')}}
                </div>
            </div>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-market.js"></script>

<style lang="scss">
@use "./property-market.scss" as *;
</style>
